"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonQuery = exports.TextQuery = exports.withCQuery = void 0;
var react_1 = __importStar(require("react"));
var ids = {};
var withCQuery = function (Component) { return function (props) {
    var _a = react_1.useState(props), innerProps = _a[0], setInnerProps = _a[1];
    react_1.useEffect(function () {
        setInnerProps(props);
    }, [props]);
    var initInstace = function (id) {
        if (!id)
            return;
        ids[id] = {
            getProps: function () {
                return innerProps;
            },
            setProps: function (newProps) {
                setInnerProps(__assign(__assign({}, innerProps), newProps));
            },
        };
    };
    react_1.useEffect(function () {
        initInstace(props.id);
        return function () {
            delete ids[props.id];
        };
    }, [props.id, innerProps]);
    return (react_1.default.createElement(Component, __assign({}, innerProps)));
}; };
exports.withCQuery = withCQuery;
var CQuery = function (id) {
    if (!id || !ids[id])
        return null;
    return ids[id];
};
var TextQuery = function (id) {
    if (!CQuery(id))
        return null;
    return {
        text: function () {
            var _a;
            if (!CQuery(id))
                return '';
            return (_a = CQuery(id)) === null || _a === void 0 ? void 0 : _a.getProps().text;
        },
        setText: function (newText) {
            var _a;
            if (!CQuery(id))
                return;
            return (_a = CQuery(id)) === null || _a === void 0 ? void 0 : _a.setProps({ text: newText });
        },
    };
};
exports.TextQuery = TextQuery;
var ButtonQuery = function (id) {
    if (!CQuery(id))
        return null;
    return {
        press: function (callback) {
            var _a;
            if (CQuery(id))
                (_a = CQuery(id)) === null || _a === void 0 ? void 0 : _a.setProps({
                    onPress: function (e) {
                        callback(e);
                    }
                });
        }
    };
};
exports.ButtonQuery = ButtonQuery;
exports.default = CQuery;
//# sourceMappingURL=CQuery.js.map